module.exports = __webpack_public_path__ + "img/drinkbg.660c6ef2.png";